export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Реєстраційні відомості"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Зберегти"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Підтверджено"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Загальнодоступно"])}
}